import api from '../../../config/axios'
import type { SensorType } from '../../../types'
import type { SensorTypeFilters } from '../../../types/api'

export const SensorTypeService = {
  getAll: (filters?: SensorTypeFilters) => 
    api.get<SensorType[]>('/sensor-types', {
      // Catalog grew with multi-range Displacement families; keep headroom
      // so dropdowns/filters don't silently truncate.
      params: { limit: 1000, is_active: true, ...(filters || {}) },
    }).then(res => res.data),

  getById: (id: string) => 
    api.get<SensorType>(`/sensor-types/${id}`).then(res => res.data),

  create: (data: Partial<SensorType>) => 
    api.post<SensorType>('/sensor-types', data).then(res => res.data),

  update: (id: string, data: Partial<SensorType>) => 
    api.put<SensorType>(`/sensor-types/${id}`, data).then(res => res.data),

  delete: (id: string) => 
    api.delete(`/sensor-types/${id}`),
}
